import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';

const editorImgs = {
  1: 'https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.jpg',
  2: 'https://d2nb51khh83712.cloudfront.net/static-assets/images/editor2.jpeg',
  3: 'https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-3-compressor.jpg',
  4: 'https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-4-compressor.jpg',
};

const colors = [
  {
    name: 'yellow',
    code: '#FFA340',
  },
  {
    name: 'blue',
    code: '#4A90E2',
  },
  {
    name: 'red',
    code: '#FF4B62',
  },
  {
    name: 'green',
    code: '#AF5EFF',
  },
];

function EditorSection({ workflow, t, btnPosition, sTitleColor, bgColor }) {
  const [isPreviewPlaying, setIsPreviewPlaying] = useState(false);
  const [activeColor, setActiveColor] = useState('yellow');
  const [activeImage, setActiveImage] = useState();
  const [activeTextBox, setActiveTextBox] = useState();
  let interval;
  let counter = 0;

  const EditorContainer = useRef(null);

  function changeBg(id, imageId) {
    if (!isPreviewPlaying) {
      setActiveImage(imageId);
      const wrapper = document.querySelectorAll(
        '.elements .image-wrapper .media-wrapper',
      );
      for (let i = 0; i < wrapper.length; i++) {
        wrapper[i].classList.remove('selected');
      }

      const image = document.getElementById(id);
      image.parentNode.parentNode.classList.add('selected');
      const url = editorImgs[imageId];
      const bg = document.getElementById('bg_media');
      bg.parentNode.children[2].srcset = url; // For Safari __|__
      bg.setAttribute('src', url);
      bg.parentElement.firstElementChild.setAttribute('srcset', url);
      bg.parentElement.children[1].setAttribute('srcset', url);
    }
  }

  function animatePreview() {
    if (!isPreviewPlaying) {
      setIsPreviewPlaying(true);
      const preview = document.getElementById('preview-window');
      preview.classList.add('animate');

      const video = document.getElementById('vid1');
      const url = video.getAttribute('data-src');
      video.setAttribute('src', url);
      // video.play();

      return setTimeout(() => {
        video.currentTime = 0;
        video.setAttribute('src', 'none');
        preview.classList.remove('animate');
        setIsPreviewPlaying(false);
      }, 5000);
    }
  }

  function changeTb(id) {
    if (!isPreviewPlaying) {
      setActiveTextBox(id);
      const wrapper = document.querySelectorAll(
        '.elements .text-wrapper .tb-wrapper',
      );
      for (let i = 0; i < wrapper.length; i++) {
        wrapper[i].classList.remove('selected');
      }

      const url = `/landing-images/${id}.png`;
      const video = document.getElementById('vid1');
      video.setAttribute('src', url);
      video.setAttribute('data-src', url);

      const thumbnail = document.getElementById(id);
      thumbnail.parentNode.classList.add('selected');
      const thumbnailUrl = thumbnail.getAttribute('src');
      const previewThumbnail = document.getElementById('preview-thumbnail');
      previewThumbnail.setAttribute('src', thumbnailUrl);
    }
  }

  function changeColor(color, id) {
    if (!isPreviewPlaying) {
      setActiveColor(id);

      const rgb = getRGB(color);
      const black = getRGB('#FFFFFF');
      createFilter(black, rgb);

      const vid = document.getElementById('preview-thumbnail');
      vid.style.filter = 'none';
      setTimeout(() => {
        vid.style.filter = 'url("#color_correction")';
      }, 0);
    }
  }

  function createFilter(color1, color2) {
    const svg = document.getElementById('color_svg');

    const filterId = 'color_correction';

    const filter = `<feComponentTransfer color-interpolation-filters="sRGB" result="duotone_2">
          <feFuncR type="table" tableValues="${color1[0]} ${color2[0]}"></feFuncR>
          <feFuncG type="table" tableValues="${color1[1]} ${color2[1]}"></feFuncG>
          <feFuncB type="table" tableValues="${color1[2]} ${color2[2]}"></feFuncB>
          <feFuncA type="table" tableValues="0 1"></feFuncA>
      </feComponentTransfer>`;

    const matrix = `<filter id =${filterId}>
      <feColorMatrix type="matrix" values="0.2126 0.7152 0.0722 0 0
          0.2126 0.7152 0.0722 0 0
          0.2126 0.7152 0.0722 0 0
          0 0 0 1 0" result="gray">
      </feColorMatrix>${filter}</filter>`;

    svg.innerHTML = matrix;
  }

  function getRGB(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return [r / 255, g / 255, b / 255];
  }

  function start() {
    if (EditorContainer.current) {
      interval = setInterval(() => {
        let flag = true;
        EditorContainer.current.scrollTo(
          EditorContainer.current.scrollLeft + 1,
          0,
        );
        const parentClientWidth = EditorContainer.current.clientWidth;
        const parentScrollWidth = EditorContainer.current.scrollWidth;
        const parentScrollLeft = EditorContainer.current.scrollLeft;

        if (parentScrollWidth - parentScrollLeft === parentClientWidth) {
          counter += 1;
          const kids = EditorContainer.current.querySelectorAll(
            '.template-wrapper',
          );
          if (counter === 2 && kids[0]) {
            const removeElement = kids[0];
            removeElement.parentNode.removeChild(removeElement);
            counter = 0;
            flag = false;
          }

          if (flag) {
            const element = document.querySelectorAll('.template-wrapper');
            if (element[0]) {
              const newEle = element[0].cloneNode(true);
              EditorContainer.current.append(newEle);
              // delete newEle;
            }
          }
        }
      }, 10);
    }
  }

  function stop() {
    clearInterval(interval);
  }

  useEffect(() => {
    const container = EditorContainer.current;
    if (container) {
      container.addEventListener('mouseover', () => {
        stop();
      });

      container.addEventListener('mouseout', () => {
        if (window.innerWidth >= 767) {
          // start();
        }
      });
    }
    return () => {
      if (container) {
        container.removeEventListener('mouseover', stop);
      }
    };
  }, []);

  return (
    <EditroWrapper className="flat section editor" sTitleColor={sTitleColor}>
      <div className="container mx-auto" ref={EditorContainer}>
        <div className="mx-auto">
          <h2 className="section-title text-white text-center capitalize">
            {t('editor.title')}
          </h2>
          <p className="description text-white text-center m-0">
            {t('editor.subTitle')}
          </p>
        </div>
        <div className="w-full main-content">
          <div className="flex flex-row-reverse justify-between">
            <div className="w-5/12 px-4">
              <div className="preview-wrapper">
                <div
                  className="preview-window"
                  id="preview-window"
                  onClick={animatePreview}
                  aria-hidden
                >
                  <div className="media-wrapper layer">
                    <picture>
                      <source
                        media="(max-width: 750px)"
                        sizes="1px"
                        srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w"
                      />
                      <source
                        type="image/webp"
                        srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.jpeg"
                      />
                      <img
                        id="bg_media"
                        className="z-depth-1 bg"
                        loading="lazy"
                        data-src="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.jpeg"
                        alt="preview-thumbnail"
                      />
                    </picture>
                  </div>
                  <div className="layer tb">
                    <img
                      id="vid1"
                      src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb-1-new.png"
                      data-src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb1.png"
                      alt="preview-thumbnail"
                      loading="lazy"
                    />
                  </div>
                  <div className="layer tb preview">
                    <img
                      id="preview-thumbnail"
                      src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb-1-new.png"
                      alt="preview-thumbnail"
                      loading="lazy"
                    />
                  </div>
                  <svg className="color_correction" id="color_svg">
                    <filter id="color_correction">
                      <feColorMatrix
                        type="matrix"
                        values="0.2126 0.7152 0.0722 0 0
                                                0.2126 0.7152 0.0722 0 0
                                                0.2126 0.7152 0.0722 0 0
                                                0 0 0 1 0"
                        result="gray"
                      />
                      <feComponentTransfer
                        colorInterpolationFilters="sRGB"
                        result="duotone_2"
                      >
                        <feFuncR type="table" tableValues="1 1" />
                        <feFuncG
                          type="table"
                          tableValues="1 0.6392156862745098"
                        />
                        <feFuncB
                          type="table"
                          tableValues="1 0.25098039215686274"
                        />
                        <feFuncA type="table" tableValues="0 1" />
                      </feComponentTransfer>
                    </filter>
                  </svg>
                  <div className="action">
                    <svg
                      width="60"
                      height="60"
                      viewBox="0 0 60 60"
                      fill="none"
                      className="icon"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30 5C16.2 5 5 16.2 5 30C5 43.8 16.2 55 30 55C43.8 55 55 43.8 55 30C55 16.2 43.8 5 30 5Z"
                        fill="white"
                      />
                      <path d="M26 40L39 30L26 20V40Z" fill="black" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="action-wrapper text-center">
                <div className="action">
                  <h3
                    className="btn btn-black"
                    aria-hidden
                    data-toggle="modal"
                    data-target="#authModal"
                    onClick={() => workflow(null, btnPosition)}
                  >
                    Make My Own Video <span className="arrow" />
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="elements">
                <div className="image-wrapper element-block">
                  <p className="wrapper-title">{t('editor.AddImages')}</p>
                  <div className="flex">
                    <div className="col-3">
                      <button
                        className="media-wrapper selected"
                        onClick={() => changeBg('img1', '1')}
                      >
                        <picture>
                          <source
                            media="(max-width: 750px)"
                            sizes="1px"
                            srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w"
                          />
                          <source
                            type="image/webp"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.webp"
                          />
                          <source
                            type="image/png"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.jpg"
                          />
                          <img
                            className="z-depth-1"
                            loading="lazy"
                            data-src="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-1-compressor.jpg"
                            alt="Woman doing Yoga"
                            id="img1"
                          />
                        </picture>
                        <span className="overlay" />
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        className="media-wrapper"
                        onClick={() => changeBg('img2', '2')}
                      >
                        <picture>
                          <source
                            media="(max-width: 750px)"
                            sizes="1px"
                            srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w"
                          />
                          <source
                            type="image/webp"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor2.webp"
                          />
                          <source
                            type="image/png"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor2.jpeg"
                          />
                          <img
                            className="z-depth-1"
                            loading="lazy"
                            data-src="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor2.jpeg"
                            alt="Beach"
                            id="img2"
                          />
                        </picture>
                        <span className="overlay" />
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        className="media-wrapper"
                        onClick={() => changeBg('img3', '3')}
                      >
                        <picture>
                          <source
                            media="(max-width: 750px)"
                            sizes="1px"
                            srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w"
                          />
                          <source
                            type="image/webp"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-3-compressor.webp"
                          />
                          <source
                            type="image/png"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-3-compressor.jpeg"
                          />
                          <img
                            className="z-depth-1"
                            loading="lazy"
                            data-src="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-3-compressor.jpeg"
                            alt="Food"
                            id="img3"
                          />
                        </picture>
                        <span className="overlay" />
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        className="media-wrapper"
                        onClick={() => changeBg('img4', '4')}
                      >
                        <picture>
                          <source
                            media="(max-width: 750px)"
                            sizes="1px"
                            srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 1w"
                          />
                          <source
                            type="image/webp"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-4-compressor.webp"
                          />
                          <source
                            type="image/png"
                            srcSet="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-4-compressor.jpeg"
                          />
                          <img
                            className="z-depth-1"
                            loading="lazy"
                            data-src="https://d2nb51khh83712.cloudfront.net/static-assets/images/editor-4-compressor.jpeg"
                            alt="Real Estate"
                            id="img4"
                          />
                        </picture>
                        <span className="overlay" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="color-wrapper element-block">
                  <p className="wrapper-title">{t('editor.SelectColours')}</p>
                  <div className="flex">
                    {colors.map(c => (
                      <div className="col-3" key={c.code}>
                        <button
                          className={`color ${
                            c.name === activeColor ? 'selected' : ''
                          }`}
                          aria-label={c.name}
                          onClick={() => changeColor(c.code, c.name)}
                        >
                          <div className={`color-box ${c.name}`} id={c.name} />
                          <span className="overlay" />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="text-wrapper element-block">
                  <p className="wrapper-title">{t('editor.AddTextBoxes')}</p>
                  <div className="flex">
                    <div className="col-3">
                      <button
                        className="tb-wrapper selected"
                        onClick={() => changeTb('tb-1')}
                      >
                        <img
                          src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb-1-new.png"
                          alt="text 1"
                          loading="lazy"
                          id="tb-1"
                        />
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        className="tb-wrapper"
                        onClick={() => changeTb('tb-2')}
                      >
                        <img
                          src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb-2.png"
                          alt="text 2"
                          loading="lazy"
                          id="tb-2"
                        />
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        className="tb-wrapper"
                        onClick={() => changeTb('tb-3')}
                      >
                        <img
                          src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb-3.png"
                          alt="text 3"
                          loading="lazy"
                          id="tb-3"
                        />
                      </button>
                    </div>
                    <div className="col-3">
                      <button
                        className="tb-wrapper"
                        onClick={() => changeTb('tb-4')}
                      >
                        <img
                          src="https://d2nb51khh83712.cloudfront.net/static-assets/images/tb-4.png"
                          alt="text 4"
                          loading="lazy"
                          id="tb-4"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </EditroWrapper>
  );
}

export default EditorSection;

const EditroWrapper = styled.section`
  padding: 100px 0px;
  background-color: #1f252d;

  ${props => `background-color: ${props.bgColor || '#1f252d'};`}

  .section-title {
    font-size: 35px;
    font-weight: 500;
    letter-spacing: 0.5;
    line-height: 1.4;
    margin-bottom: 20px;

    ${props => `color: ${props.sTitleColor || 'white'};`}
  }

  .description {
    font-size: 16px;
    letter-spacing: 0.5;
    line-height: 1.59;
  }

  .main-content {
    margin-top: 60px;
    .left-panel {
      display: inline-block;
      vertical-align: top;
    }

    .elements {
      display: inline-block;
      padding-left: 20px;

      .element-block {
        &:first-of-type {
          margin-top: 0px;
        }
        margin: 50px 0px;

        .z-depth-1 {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
      .wrapper-title {
        margin: 10px 0px 20px;
        font-size: 17px;
        color: #d8e6ff;
        letter-spacing: 0.5;
      }

      .media-wrapper,
      .color,
      .tb-wrapper {
        position: relative;
        cursor: pointer;
        transition: all 0.5s ease;
        width: 100px;
        height: 100px;
        text-align: center;
        margin: 10px 15px;
        outline: none;

        img {
          cursor: pointer;
          border-radius: 5px;
        }

        &:hover {
          transform: scale(1.05);
        }

        .overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          border-radius: 5px;
        }

        &.selected {
          transform: scale(1.25);
          .overlay {
            display: none;
          }
          &:hover {
            transform: scale(1.25);
          }
        }
      }

      .tb-wrapper {
        background: rgba(255, 255, 255, 0.4);
        border-radius: 5px;
        /* height: 100px; */
        /* width: 100px; */
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding: 0px 5px;
        img {
          border-radius: 0px;
        }
      }
    }

    .preview-wrapper {
      /* height: 100%; */
      margin-top: 15%;

      .preview-window {
        /* width: auto; */
        /* height: 400px; */
        padding-top: 100%;
        position: relative;

        margin-top: 40px;

        &.animate {
          .layer {
            &.tb {
              img {
                &#vid1 {
                  display: block;
                }
              }
            }
          }
          img {
            transition: all 4s ease;
            transform: scale(1.2);
          }

          .preview {
            display: none;
          }

          .action {
            opacity: 0;
            .icon {
              display: none;
            }
          }
        }

        .action {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0, 0, 0, 0.25);
          z-index: 2;
          font-size: 52px;
          cursor: pointer;
          border-radius: 5px;
          opacity: 1;
          animation: all 2s ease-in;

          .icon {
            animation: pulse-black 1s infinite;
            border-radius: 50%;
            width: 60px;
            height: 60px;
          }
        }

        .preview {
          img {
            filter: url('#color_correction');
          }
        }

        img {
          cursor: pointer;
        }

        .layer {
          position: absolute;
          top: 0px;
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          overflow: hidden;

          &.media-wrapper {
            border-radius: 5px;
          }

          &.tb {
            width: auto;
            height: auto;
            left: 50%;
            transform: translateX(-50%);
            bottom: 30px;
            top: auto;

            img {
              width: 100%;
              &#vid1 {
                width: 100%;
                filter: url(#color_correction);
                transform: none;
                display: none;
              }
            }

            video {
              width: 100%;
              filter: url('#color_correction');
            }
          }
        }

        .color_correction {
          position: absolute;
          left: -9999em;
          padding: 0px;
          margin: 0px;
          width: 0px;
        }
      }

      .edit {
        padding: 40px 0px;
        text-align: center;
      }
    }

    .action-wrapper {
      opacity: 0;
    }
  }

  .bottom-action {
    /* margin: 30px 0px 0px; */
    text-align: center;

    .text {
    }

    .action {
      margin: 30px 0px 0px;
    }
  }

  .color-box {
    width: 100%;
    height: 100px;
    border-radius: 5px;
  }

  .yellow {
    background: #ffa340;
  }
  .blue {
    background: #4a90e2;
  }
  .red {
    background: #ff4b62;
  }
  .green {
    background: #af5eff;
  }

  @media (max-width: 767px) {
    display: none;
  }
`;
